import { useRef } from "react";

import { useClearUrlOnTerminalChange } from "./useClearUrlOnTerminalChange";
import { useUrlToGlobalTerminalSync } from "./useUrlToGlobalTerminalSync";

export const useTerminalUrlSync = (
  urlSelectedTerminalId: number | null,
  globalTerminalId: number | undefined,
  setGlobalTerminalId: (data: { terminal_id: number[] }) => void
) => {
  const isApplyingUrlTerminal = useRef(false);
  const hasTerminalMismatch = urlSelectedTerminalId !== null && urlSelectedTerminalId !== globalTerminalId;

  useUrlToGlobalTerminalSync(
    urlSelectedTerminalId,
    globalTerminalId,
    setGlobalTerminalId,
    isApplyingUrlTerminal,
    hasTerminalMismatch
  );

  useClearUrlOnTerminalChange(globalTerminalId, urlSelectedTerminalId, isApplyingUrlTerminal);

  return hasTerminalMismatch;
};
